<template>
  <div id="warp">
    <div id="action">
      <div>
        <div>
          <h1>{{ $t('common.payout') }}</h1>
        </div>
        <a :title="$t('common.back')" @click="$router.push({ name: 'cardSelect' })">
          {{ $t('common.back') }}
        </a>
      </div>

      <div>
        <form>
          <fieldset class="hide_triangle">
            <div class="showConfirmMessage">
              <h3>{{ $t('check.email') }}</h3>
              <p v-text="displayMessage"></p>
              <img src="~@/assets/img/mail.svg" :alt="$t('common.mail')" />
            </div>
          </fieldset>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MessageChangeOfPaymentMethod',
  computed: {
    displayMessage() {
      if (this.isCurrencyCrypto) {
        return this.$t('wallet.change.secure.message');
      }

      return this.$t('change.card.for.payouts.secure');
    },
    ...mapGetters(['isCurrencyCrypto']),
  },
};
</script>

<style lang="sass">
  .showConfirmMessage
    position: relative

    h3
      margin-bottom: 25px
      font-size: 1.12rem

    p
      font-size: .9rem
      max-width: 80%

    img
      position: absolute
      right: .64rem
      top: .64rem

      @media (max-width: 480px)
        max-width: 50px
        right: 0
        top: 0
</style>
